<template>
  <div class="index-container">
    <!-- 首页 -->
    <el-carousel class="index-banner-box" height="530px" :autoplay="false">
      <el-carousel-item
        v-for="(item, index) in bannerList"
        :key="index"
        class="banner-item"
      >
        <img
          class="banner-img"
          :src="item.bannerPath"
          @click="handleCarousel(item)"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="recommended-artwork-box">
      <div class="the-body-box">
        <div class="clearfix">
          <div class="f-l title-box">
            <div class="name">{{ $t("IndexNavbar.RecommendArtwork") }}</div>
            <div class="en-name">Recommended artwork</div>
            <div class="line"></div>
          </div>
          <div class="f-r category-box text-right">
            <span
              class="item"
              v-for="(item, i) in artCategoryList"
              :class="item.kindId == currArt ? 'active' : ''"
              :key="i"
              @click="changeArt(item.kindId)"
              >{{ item.chKindName }}</span
            >
            <!-- <span class="item">国画</span> -->
            <router-link class="more-btn text-center" to="/artwork-list"
              >MORE</router-link
            >
          </div>
        </div>
        <div class="artwork-list-box">
          <el-row :gutter="24">
            <el-col :span="8" v-for="(item, i) in artList" :key="i">
              <div class="artwork-card" v-if="i < 3">
                <router-link
                  :to="`/artwork-detail?artworkId=${item.artworkId}`"
                >
                  <div class="artwork-img-box">
                    <h5 v-if="item.status != 5">
                      {{
                        item.status === 6
                          ? "已售出"
                          : item.status === 7
                          ? "已下架"
                          : ""
                      }}
                    </h5>
                    <!-- <img class="art-img" :src="item.logoPath" alt=""> -->
                    <div
                      class="art-img bg-img-center"
                      :style="{
                        'background-image': 'url(' + item.logoPath + ')',
                      }"
                    ></div>
                  </div>
                  <div class="text-box">
                    <div>{{ item.chArtworkName }}</div>
                    <div class="mid-text">{{ item.chArtistName }}</div>
                    <div class="clearfix">
                      <span class="f-l">{{ $t("PriceUnit") }} {{ item.price | fnKeep }}</span>
                      <span class="f-r">{{ item.chKindName }}</span>
                    </div>
                  </div>
                </router-link>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <pc-video :videoData="video1"></pc-video>
    <div class="the-body-box">
      <div class="title-box">
        <div class="name">{{ $t("LastTranslate.title2") }}</div>
        <div class="en-name">How to register</div>
        <div class="line"></div>
      </div>
      <div class="video-box">
        <pc-video :videoData="video2"></pc-video>
      </div>
    </div>
    <div
      class="banner-item img-ad"
      :style="`background-image: url(${indexAd});`"
    ></div>
    <div class="about-us-box the-body-box">
      <el-row>
        <el-col :span="15">
          <div class="about-left-box">
            <div class="title-box">
              <div class="name">{{ $t("IndexNavbar.AboutUs") }}</div>
              <div class="en-name">About us</div>
              <div class="line"></div>
            </div>
            <img src="../../../../assets/img/index-brand.jpg" />
            <div class="title">{{ $t("FooterNavbar.SiteName") }}</div>
            <div class="web-link">www.KingsArts.com</div>
            <div class="content">{{ $t("IndexAboutUs.Introduce") }}</div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="about-right-box">
            <div class="title">{{ $t("LastTranslate.title3") }}</div>
            <div class="web-link">{{ $t("LastTranslate.title4") }}</div>
            <pc-video :videoData="video3"></pc-video>
            <div class="content text-mar">{{ $t("LastTranslate.Address") }}</div>
            <div class="content">{{ $t("LastTranslate.Tel") }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="the-news-box">
      <div class="the-body-box">
        <div class="clearfix">
          <div class="f-l title-box">
            <div class="name">{{ $t("IndexNavbar.LatestNews") }}</div>
            <div class="en-name">Latest news</div>
            <div class="line"></div>
          </div>
          <div class="f-r category-box text-right">
            <router-link class="more-btn text-center" to="/latest-news"
              >MORE</router-link
            >
          </div>
        </div>
        <div class="news-list">
          <div class="news-item" v-for="(item, i) in newsList" :key="i">
            <router-link
              :to="`/news-detail?informationId=${item.informationId}`"
              class="common-flex-box"
            >
              <img :src="item.logoPath" class="news-img" />
              <div class="right-text-box">
                <div class="news-title ellipsis" v-html="item.chTitle"></div>
                <div class="news-content" v-html="item.chAbstract"></div>
                <div class="text-light-gray">{{ item.updateTime }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="recommended-artist-box the-body-box">
      <div class="clearfix">
        <div class="f-l title-box">
          <div class="name">{{ $t("IndexNavbar.RecommendArtists") }}</div>
          <div class="en-name">Recommended artist</div>
          <div class="line"></div>
        </div>
        <div class="f-r category-box text-right">
          <span
            class="item"
            v-for="(item, i) in artistList"
            :class="item.labelId == currArtist ? 'active' : ''"
            :key="i"
            @click="changeArtist(item.labelId)"
            >{{ item.chLabelName }}</span
          >
          <!-- <span class="item">国画</span> -->
          <router-link class="more-btn text-center" to="/artist-list"
            >MORE</router-link
          >
        </div>
      </div>
      <el-carousel :interval="5000" arrow="always" height="384px">
        <el-carousel-item v-for="(item, r) in recommendArt" :key="r">
          <div class="artist-detail-box common-flex-box">
            <router-link
              class="artist-detail-box common-flex-box"
              :to="`/artist-detail?artistId=${item.artistId}`"
              style="flex: 0 0 624px"
            >
              <img class="artist-img" :src="item.picPath" alt="" />
              <div class="detail-text">
                <div class="name">{{ item.chArtistName }}</div>
                <div class="text">
                  <span v-for="(val, i) in item.artistLabelList" :key="i">
                    {{ val.chLabelName }}
                    <span v-if="i < item.artistLabelList.length - 1">、</span>
                  </span>
                </div>
                <!-- <div class="text">{{item.chIntro}}</div> -->
                <div class="text-mar">
                  <div class="text">
                    {{ $t("IndexNavbar.Artwork") }} {{ item.artworkCount }}
                    {{ $t("IndexNavbar.Pieces") }}
                  </div>
                  <div class="text ellipsis-five">{{ item.chIntro }}</div>
                  <!-- <div class="text">毕业于广州美术学院</div> -->
                </div>
                <!-- <div class="text">MORE</div> -->
              </div>
            </router-link>
            <div class="detail-imgs">
              <el-row>
                <el-col
                  :span="8"
                  class="img-item"
                  v-for="(item, a) in item.artworkList"
                  :key="a"
                  v-if="a < 3"
                >
                  <router-link
                    :to="`/artwork-detail?artworkId=${item.artworkId}`"
                  >
                    <!-- <img :src="item.logoPath" alt=""  style="width: 100%;height: 192px;"> -->
                    <div
                      style="width: 100%; height: 192px"
                      class="bg-img-center"
                      :style="{
                        'background-image': 'url(' + item.logoPath + ')',
                      }"
                    ></div>
                  </router-link>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
import pcVideo from "../../../../components/video";
export default {
  components: {
    pcVideo,
  },
  data() {
    return {
      bannerList: [],
      artCategoryList: [],
      artistList: [],
      newsList: [],
      artList: [],
      recommendArt: [],
      currArt: 0,
      currArtist: 0,
    };
  },
  computed: {
    indexAd () {
      const locale = this.$store.state.locale
      return locale === 'en' ? `https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/index-qrcode-en.jpg?t=${new Date().getTime()}` : `https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/index-qrcode.jpg?t=${new Date().getTime()}`
    },
    video1 () {
      const locale = this.$store.state.locale
      const linkUrl = locale === 'en' ? 'https://kingsarts-video.oss-cn-hongkong.aliyuncs.com/index1.mp4' : 'http://kingsarts-video.oss-cn-hongkong.aliyuncs.com/SECnzdYYND4.mp4'
      const poster = locale === 'en' ? 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/video1_en.jpg' : require("../../../../assets/img/mp41.jpg")
      return {
        ref: "video1",
        // width: '100%',
        height: "550PX",
        poster,
        // content: '<div style="font-size: 24PX;">如何成为“经艺私人艺术管家”</div><div style="margin: 24PX 0 64PX;font-size: 48PX;font-family: none;">ART ADVISOR .</div>',
        // linkUrl: require('../../../../assets/vieo/1.mp4')
        // linkUrl: 'https://kingsarts-video.oss-cn-hongkong.aliyuncs.com/1.614bb652.mp4'
        linkUrl
      }
    },
    video2 () {
      const locale = this.$store.state.locale
      const linkUrl = locale === 'en' ? 'https://kingsarts-video.oss-cn-hongkong.aliyuncs.com/index2.mp4' : 'https://kingsarts-video.oss-cn-hongkong.aliyuncs.com/2.c2f2fc9d.mp4'
      const poster = locale === 'en' ? "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/video2_en.jpg" : require("../../../../assets/img/2.jpg")
      return {
        ref: "video2",
        // width: '100%',
        height: "464PX",
        poster,
        // linkUrl: require('../../../../assets/vieo/2.mp4')
        linkUrl,
      }
    },
    video3 () {
      const locale = this.$store.state.locale
      const linkUrl = locale === 'en' ? 'https://kingsarts-video.oss-cn-hongkong.aliyuncs.com/index3.mp4' : "https://kingsarts-video.oss-cn-hongkong.aliyuncs.com/3.0acde764.mp4"
      const poster = locale === 'en' ? 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/video3_en.jpg' : "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/video3.jpg"
      return {
        ref: "video3",
        // width: '100%',
        height: "216PX",
        poster,
        linkUrl,
        closeFontSize: "36px",
      }
    }
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
    
  },
  methods: {
    // 轮播图
    homeSwiper() {
      this.$commonPromise("get", this.$Api.homeSwiper, {
        type: this.$store.state.type,
      }).then((res) => {
        if (res.code === 200) {
          this.bannerList = res.data;
        }
      });
    },
    // 艺术品分类列表
    artworkKindList() {
      this.$commonPromise("get", this.$Api.artworkKindList, { show: 1 }).then(
        (res) => {
          if (res.code === 200) {
            this.artCategoryList = res.data;
          }
        }
      );
    },
    //艺术品分类切换
    changeArt(id) {
      this.currArt = id;
      this.recommendArtworkList(id);
    },
    // 推荐艺术品
    recommendArtworkList(kindId) {
      let Id = {
        kindId: kindId,
      };
      this.$commonPromise("get", this.$Api.recommendArtworkList, Id).then(
        (res) => {
          if (res.code === 200) {
            this.artList = res.data;
          }
        }
      );
    },
    // 最新消息
    informationList() {
      this.$commonPromise("get", this.$Api.informationList, {
        limit: 3,
        recommend: 1,
      }).then((res) => {
        if (res.code === 200) {
          this.newsList = res.data.records;
        }
      });
    },
    // 艺术家标签列表
    artistLabelList() {
      this.$commonPromise("get", this.$Api.artistLabelList, { show: 1 }).then(
        (res) => {
          if (res.code === 200) {
            this.artistList = res.data;
          }
        }
      );
    },
    // //艺术家分类
    changeArtist(id) {
      this.currArtist = id;
      this.recommendArtistList(id);
    },
    // 推荐艺术家列表
    recommendArtistList(labelId) {
      let Id = {
        labelId: labelId,
      };
      this.$commonPromise("get", this.$Api.recommendArtistList, Id).then(
        (res) => {
          if (res.code === 200) {
            this.recommendArt = res.data;
            // this.recommendArt = res.data.records;
            // // let arr =res.data.records.artistLabelList;
            // // arr.forEach(val => {
            // // 	console.log(val)
            // // })
          }
        }
      );
    },
    handleCarousel(data) {
      if (data.jumpType === 1 && data.artworkId) {
        this.$router.push({
          path: `/artwork-detail?artworkId=${data.artworkId}`,
        });
      } else if (data.jumpType === 2 && data.bannerUrl) {
        window.location.href = data.bannerUrl;
      }
    },
  },
  mounted() {
    this.homeSwiper();
    this.artworkKindList();
    this.recommendArtworkList();
    this.informationList();
    this.artistLabelList();
    this.recommendArtistList();
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  .the-body-box {
    padding: 64PX 0;
  }

  .banner-item {
    height: 100%;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
    text-align: center;

    img {
      height: 100%;
    }
  }

  .recommended-artwork-box {
    background-color: #f5f5f5;
  }

  .title-box {
    margin-bottom: 40PX;

    .name {
      font-size: 22PX;
      margin-bottom: 15PX;
    }

    .en-name {
      margin-bottom: 16PX;
      color: #ccc;
      font-size: 16PX;
    }

    .line {
      width: 30PX;
      height: 1PX;
      background-color: $main-color;
      margin-left: 1PX;
    }
  }

  .category-box {
    margin-top: 18PX;

    .item {
      display: inline-block;
      zoom: 1;
      // width: 86PX;
      height: 31PX;
      line-height: 31PX;
      margin-right: 12PX;
      font-size: 12PX;
      text-align: center;
      cursor: pointer;
      color: $text-light-gray;
      border-bottom: 1PX solid #ccc;
      padding: 0 5PX;

      &:hover {
        color: #333;
        border-color: rgba($main-color, 0.5);
        background-color: rgba($main-color, 0.5);
      }

      &.active {
        color: #333;
        border-color: $main-color;
        background-color: $main-color;
      }
    }

    .more-btn {
      display: inline-block;
      zoom: 1;
      width: 152PX;
      height: 32PX;
      line-height: 32PX;
      color: #fff;
      background-color: #333;
    }
  }

  .artwork-list-box {
    .artwork-card {
      .art-img {
        height: 360PX;
        width: 100%;
        object-fit: contain;
        background-color: #fff;
      }

      .text-box {
        padding: 14PX 14PX 11PX;
        color: #666;
        background-color: #fff;

        .mid-text {
          margin: 7PX 0 6PX;
        }
      }

      &:hover {
        box-shadow: 0 0 20PX 7PX #ccc;
      }
    }
  }

  .img-ad {
    height: 640PX;
  }

  .about-us-box {
    padding: 0;

    .about-left-box {
      padding: 64PX 60PX 64PX 0;
      border-right: 1PX solid #eee;
    }

    .about-right-box {
      padding: 132PX 0 64PX 60PX;
    }

    .title {
      margin: 40PX 0 15PX;
      font-size: 18PX;
    }

    .web-link {
      margin-bottom: 22PX;
      font-size: 16PX;
      color: #ccc;
    }

    .content {
      color: $text-light-gray;
      line-height: 1.4;

      &.text-mar {
        margin: 22PX 0 12PX;
      }
    }
  }

  .the-news-box {
    background-color: #f5f5f5;

    .news-list {
      a {
        color: #333;
      }

      .news-item {
        height: 300PX;
        background-color: #fff;

        &:not(:first-child) {
          margin-top: 40PX;
        }

        .news-img {
          width: 500PX;
          flex: 0 0 500PX;
          height: 300PX;
          object-fit: cover;
        }

        .right-text-box {
          flex: 1;
          padding: 60PX 110PX 24PX 79PX;

          .news-title {
            font-size: 16PX;
            font-weight: bold;
          }

          .news-content {
            margin: 38PX 0 8PX;
            height: 140PX;
            line-height: 1.7;
            overflow: hidden;
          }
        }
      }
    }
  }

  .recommended-artist-box {
    .artist-detail-box {
      .artist-img {
        flex: 0 0 384PX;
        height: 384PX;
        width: 384PX;
        object-fit: cover;
      }

      .detail-text {
        width: 240PX;
        height: 384PX;
        padding: 72PX 50PX;
        color: $text-light-gray;
        background-color: #333;

        .name {
          margin-bottom: 8PX;
          color: #fff;
          font-size: 16PX;
        }

        .text {
          line-height: 20PX;
        }

        .text-mar {
          margin: 38PX 0 62PX;
        }
      }

      .detail-imgs {
        flex: 1;

        .img-item:nth-child(odd) {
          margin-top: 192PX;
        }
      }
    }
  }
}
.artwork-img-box {
  position: relative;
  h5 {
    width: 100PX;
    height: 100PX;
    border-radius: 50%;
    text-align: center;
    line-height: 100PX;
    color: #fff;
    font-size: 14PX;
    transform: rotate(45deg);
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
// 省略两行
.ellipsis-five {
  overflow: hidden;
  -webkit-line-clamp: 5;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
